import { routerStyxie } from '@/router/styxieBridge'

// Reports is client-side routed: every action boots the shared router shell.
// No styxie payload — the index resolves its filter state through the API
// and the show page has always fetched GET /api/reports/:id.
Styxie.Initializers.Reports = routerStyxie({ actions: ['index', 'show']})
